module.exports = __webpack_public_path__ + "img/tg_01 (10).afcd6812.jpg";